import { REGISTER_STEP_KEY } from "../../constants/constants";
import store from "../../js/Store";
import { redirect } from "../../js/Actions";
import { clearCredentialsStorage } from "./LoginService";
import { queryClient } from "../../queries/queryClient";
import { resetTermsStatusCache } from "../TermsService";

export function storageCleanup() {
  clearCredentialsStorage();
  window.sessionStorage.removeItem(REGISTER_STEP_KEY)
  // Cached server data belongs to the session that just ended.
  queryClient.clear();
  resetTermsStatusCache();
}

export function logout() {
  storageCleanup();
  store.dispatch(redirect('/login'))
}
